import store from '../store'

import Dashboard from '../pages/dashboard/dashboard';
import ActivatedDevices from '../pages/dashboard/activated-devices';
import AssetsPage from '../pages/assets/assets';
import AssetPosition from '../pages/assets/asset-position'
import AssetAlarmPosition from '../pages/assets/asset-alarm-position'
import AssetLastAlarms from '../pages/assets/asset-last-alarms'
import AssetEdit from '../pages/assets/asset-edit'
import AssetTransfer from '../pages/assets/asset-transfer'
import DeviceCheck from '../pages/assets/device-check'
import DeviceConfig from '../pages/assets/device-config/device-config'
import ConfigInputs from '../pages/assets/device-config/config-inputs'
import ConfigVoltageAlarms from '../pages/assets/device-config/config-voltage-alarms'

import Customers from '../pages/customers/customers';
import CustomerEdit from '../pages/customers/customer-edit';
import CustomerResetPassword from '../pages/customers/customer-reset-password';
import LoginPage from '../pages/login-screen'
import PanelLeft from '../pages/panel-left'
import CreditsRecharge from '../pages/credits/recharge-credits'
import CreditsTransfer from '../pages/credits/transfer'
import CreditsTransferHistory from '../pages/credits/transfer-history'
import Notifications from '../pages/notifications/notifications'
import Notification from '../pages/notifications/notification'

import SimPosition from '../pages/sim-manage/sim-position'
import SimCommandHistory from '../pages/sim-manage/command-history'
import SimStatus from '../pages/sim-manage/sim-status'
import SimSendCommand from '../pages/sim-manage/send-command'
import SimConnectivity from '../pages/sim-manage/sim-connectivity/sim-connectivity'
import SimHLRInfo from '../pages/sim-manage/sim-connectivity/tabs/sim-hlr-info'
import SimCurrentSession from '../pages/sim-manage/sim-connectivity/tabs/sim-current-session'
import SimSessionsData from '../pages/sim-manage/sim-connectivity/tabs/sim-sessions-data'



import UserSettings from '../pages/user-settings'



import NotFoundPage from '../pages/404.vue';



var routes = [
  {
    path: '/login/',
    component: LoginPage,
  },
  {
    name: 'panel-left',
    path: '/panel-left/',
    panel: {
      component: PanelLeft,
    },
  },
  {
    name: 'user-settings',
    path: '/user-settings/',
    component: UserSettings,
    beforeEnter: checkAuth,
  },
  {
    name: 'dashboard',
    path: '/dashboard/',
    component: Dashboard,
    beforeEnter: checkAuth,
    routes: [
      {
        name: 'activated-devices',
        path: 'activated-devices/',
        component: ActivatedDevices,
        beforeEnter: checkAuth,
      },
    ]
  },
  {
    name: 'credits',
    path: '/credits/',
    routes: [
      {
        name: 'recharge-credits',
        path: 'recharge/',
        component: CreditsRecharge,
        beforeEnter: checkAuth,
      },
      {
        name: 'credits-transfer',
        path: 'transfer/',
        component: CreditsTransfer,
        beforeEnter: checkAuth,
      },
      {
        name: 'credits-transfer-history',
        path: 'transfer-history/',
        component: CreditsTransferHistory,
        beforeEnter: checkAuth,
      },
    ]
  },

  {
    name: 'assets',
    path: '/assets/',
    component: AssetsPage,
    beforeEnter: checkAuth,
    routes: [
      {
        name: 'asset-position',
        path: 'position/',
        component: AssetPosition,
        beforeEnter: checkAuth,
      },
      {
        name: 'asset-last-alarms',
        path: 'last-alarms/',
        component: AssetLastAlarms,
        beforeEnter: checkAuth,
      },
      {
        name: 'asset-alarm-position',
        path: 'alarm-position/',
        component: AssetAlarmPosition,
        beforeEnter: checkAuth,
      },
      {
        name: 'asset-edit',
        path: 'edit/',
        component: AssetEdit,
        beforeEnter: checkAuth,
      },
      {
        name: 'asset-transfer',
        path: 'transfer/',
        component: AssetTransfer,
        beforeEnter: checkAuth,
      },
      {
        name: 'device-check',
        path: 'device-check/',
        component: DeviceCheck,
        beforeEnter: checkAuth,
      },
      {
        name: 'device-config',
        path: 'device-config/',
        component: DeviceConfig,
        beforeEnter: checkAuth,
        routes: [
          {
            name: 'config-inputs',
            path: 'inputs/',
            component: ConfigInputs,
            beforeEnter: checkAuth,
          },
          {
            name: 'config-voltage-alarms',
            path: 'power/',
            component: ConfigVoltageAlarms,
            beforeEnter: checkAuth,
          },
        ]
      },
    ]
  },
  {
    name: 'sim-manage',
    path: '/sim/',
    //component: AssetsPage,
    //beforeEnter: checkAuth,
    routes: [
      {
        name: 'command-history',
        path: 'command-history/',
        component: SimCommandHistory,
        beforeEnter: checkAuth,
      },
      {
        name: 'sim-status',
        path: 'sim-status/',
        component: SimStatus,
        beforeEnter: checkAuth,
        routes: [          
          {
            name: 'sim-position',
            path: 'position/',
            component: SimPosition,
            beforeEnter: checkAuth,
          },
        ]
      },
      {
        name: 'sim-send-command',
        path: 'send-command/',
        component: SimSendCommand,
        beforeEnter: checkAuth,
      },
      {
        name: 'sim-connectivity',
        path: 'connectivity/',
        component: SimConnectivity,
        beforeEnter: checkAuth,
        tabs: [
          {
            path: 'hlr-info/',
            id: 'tab-hlr-info',
            component: SimHLRInfo,
          },
          {
            path: 'current-session/',
            id: 'tab-current-session',
            component: SimCurrentSession,
          },
          {
            path: 'sessions-data/',
            id: 'tab-sessions-data',
            component: SimSessionsData,
          },
        ]
      },
    ]
  },
  {
    name: 'customers',
    path: '/customers/',
    component: Customers,
    beforeEnter: checkAuth,
    routes: [
      {
        name: 'customer-reset-password',
        path: 'reset-password/',
        component: CustomerResetPassword,
        beforeEnter: checkAuth,
      },
      {
        name: 'customer-edit',
        path: 'edit/',
        component: CustomerEdit,
        beforeEnter: checkAuth,
      },
    ]
  },
  {
    name: 'notifications',
    path: '/notifications/',
    component: Notifications,
    //beforeEnter: checkAuth,
    routes: [
      {
        name: 'notification',
        path: 'notification/',
        component: Notification,
        beforeEnter: checkAuth,
      },
    ]
  },



  {
    path: '(.*)',
    component: NotFoundPage,
  },
];


function checkAuth({ to, from, resolve, reject, router }) {
  //console.log(store.getters.IS_LOGGED_IN)
  if (store.getters.IS_LOGGED_IN) {
    resolve();
  } else {
    reject();
    router.navigate('/login/');
  }
}

export default routes;
